module.exports = __webpack_public_path__ + "img/detail-mode1-3.5aeab687.png";